module.exports = __webpack_public_path__ + "static/media/minus_orange_fade.6d7e4b16.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/minus_orange_fade.png
 ** module id = 45
 ** module chunks = 0
 **/